import type { DocumentsListing } from '@contracts/document/DocumentResponse';
import { documentsQueryKeys } from '@src/documents/queryKeys';
import { DocumentsClient } from '@src/documents/services/DocumentsClient';
import { useQuery } from '@tanstack/react-query';

export const getLastPartOfPath = (path: string): string => {
  const lastSlashIndex = path.lastIndexOf('/');
  return lastSlashIndex !== -1 ? path.substring(lastSlashIndex + 1) : path;
};

export const useFindAllDocumentsForOrder = (orderId: string) => {
  const { data: documents = [], refetch } = useQuery<DocumentsListing[]>({
    queryKey: documentsQueryKeys.byOrderId(orderId),
    queryFn: () => DocumentsClient.findAllForOrder(orderId),
  });

  return {
    documents,
    refetch,
  };
};
